export const PlayIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22.9229V9.07666L22.8718 15.9998L12 22.9229Z" fill="white" />
    </svg>
  )
}
